import React, {
  useContext, useEffect, useState,
} from 'react';
import { useIntl } from 'react-intl';
import {
  NavLink, Route, Switch, useRouteMatch,
} from 'react-router-dom';
import { useParams } from 'react-router';

import Carbon from '../Carbon';
import CarbonCredits from './CarbonCredits/CarbonCredits';
import './CarbonPage.scss';
import CustomBtn from '../../../../generic/CustomBtn';
import getConfig from '../../../../config';
import { appStore } from '../../../../state/app';
import { getOccRewardsByStages, getOccTotalRewardsForProject } from '../../../../services/requestOccContract';
import { getTotalDataByStage } from '../../../../utils/helpers';

const CarbonPage = ({ projectData }) => {
  const translate = useIntl();
  const { path, url } = useRouteMatch();
  const [occData, setOccData] = useState({
    total: null,
    byStages: [],
    totalForAllStage: null,
  });
  const { walletOFPUrl } = getConfig();
  const { nameId } = useParams();
  const { state: { account } } = useContext(appStore);
  const getDataCarbon = async () => {
    try {
      const total = await getOccTotalRewardsForProject(account, nameId);
      const byStages = await getOccRewardsByStages(account, nameId);
      const totalForAllStage = getTotalDataByStage(byStages);

      return {
        total,
        byStages,
        totalForAllStage,
      };
    } catch (error) {
      console.log(error, 'error');
      return {
        total: null,
        byStages: [],
        totalForAllStage: null,
      };
    }
  };
  useEffect(() => {
    async function fetchData() {
      const response = await getDataCarbon();
      setOccData(response);
    }
    fetchData();
  }, []);
  const TabsData = [
    {
      label: translate.formatMessage({ id: 'carbon.form.credits' }),
      content: <CarbonCredits stages={projectData?.stages} occData={occData} />,
      link: '',
      path: `${path}`,
      tabId: 1,
    },
    {
      label: translate.formatMessage({ id: 'carbon.form.application' }),
      content: <Carbon projectData={projectData} />,
      link: '/application',
      path: `${path}/application`,
      tabId: 2,
    },
  ];

  return (
    <div className="carbon-page">
      <div className="carbon-page__monitoring-wrapper">
        <div className="carbon-page__monitoring">
          {TabsData.map((tab) => (
            <NavLink
              key={tab.tabId}
              to={`${url}${tab.link}`}
              className="carbon-page__link"
              activeClassName="carbon-page__link-active"
              exact
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
        {/* <div className="wrapper-btn"> */}
        {!!(occData?.total || occData?.byStages.length) && (
        <CustomBtn
          label={translate.formatMessage({ id: 'carbon.sendOCC' })}
          handleClick={() => {
            window.open(walletOFPUrl);
          }}
          type="button"
          customClass="wrapper-btn"
        />
        )}
        {/* </div> */}
      </div>
      <div className="dividing-line" />
      <div className="carbon-form__tab-body">
        <Switch>
          {TabsData
            .map((tab, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Route key={index} exact path={tab.path}>
                {tab.content}
              </Route>
            ))}
        </Switch>
      </div>
    </div>
  );
};

export default CarbonPage;
